import React from 'react';
import { Link } from 'react-router-dom';

// "Apps, on a foundation" — the capability spotlight. Ana builds full
// applications on the nventr foundation: realtime data, booking engines,
// uploads, voice agents, admin consoles, fan-out compute. The widget grid
// shows the product itself (Daybreak pattern) as live .ac components with
// subtle CSS motion — no stock screenshots.

// Deterministic mini-calendar: 28 cells, a handful booked.
const CAL_ON = new Set([3, 8, 11, 16, 22, 25]);

function WidgetGrid() {
  return (
    <div className="ac-widgets" aria-hidden="true">
      <div className="ac-widget ac-reveal" style={{ '--d': '0.1s' }}>
        <span className="ac-widget-k">Booking</span>
        <div className="ac-widget-cal">
          {Array.from({ length: 28 }, (_, i) => (
            <span key={i} className={CAL_ON.has(i) ? 'on' : ''} />
          ))}
        </div>
        <span className="ac-widget-line">Race-free slots, live availability</span>
      </div>
      <div className="ac-widget ac-reveal" style={{ '--d': '0.18s' }}>
        <span className="ac-widget-k">Admin</span>
        <div className="ac-widget-rows">
          {['68%', '82%', '55%', '74%'].map((w, i) => (
            <div className="ac-widget-row" key={i}>
              <i style={{ width: w }} />
              <em className={i === 1 ? 'alt' : ''} />
            </div>
          ))}
        </div>
        <span className="ac-widget-line">Owner console, one login</span>
      </div>
      <div className="ac-widget ac-reveal" style={{ '--d': '0.26s' }}>
        <span className="ac-widget-k">Voice</span>
        <div className="ac-widget-wave">
          {Array.from({ length: 14 }, (_, i) => (
            <span key={i} style={{ '--i': i }} />
          ))}
        </div>
        <span className="ac-widget-line">An agent that answers calls</span>
      </div>
      <div className="ac-widget ac-reveal" style={{ '--d': '0.34s' }}>
        <span className="ac-widget-k">Live</span>
        <div className="ac-widget-metric">99.98<span>%</span></div>
        <svg className="ac-widget-spark" viewBox="0 0 100 26" preserveAspectRatio="none">
          <path d="M0 20 L12 16 L24 18 L36 10 L48 13 L60 7 L72 9 L84 4 L100 6" fill="none" stroke="currentColor" strokeWidth="1.6" />
        </svg>
        <span className="ac-widget-line">Uptime, watched around the clock</span>
      </div>
    </div>
  );
}

export default function AppsBand({ compact = false }) {
  return (
    <section className={`ac-apps ac-on-ink ${compact ? 'compact' : ''}`} id="apps">
      <div className="ac-lightwash" aria-hidden="true" />
      <div className="ac-wrap ac-apps-inner">
        <div className="ac-apps-copy">
          <span className="ac-kicker ac-reveal">Apps, on a foundation</span>
          <h2 className="ac-reveal" style={{ '--d': '0.06s' }}>
            Not just websites. <em>Working software.</em>
          </h2>
          <p className="ac-reveal" style={{ '--d': '0.12s' }}>
            The studio builds full applications on the nventr foundation —
            realtime data, booking engines, client uploads, voice agents, admin
            consoles, heavy compute. Highly performant, endlessly customizable,
            and maintained under the same monthly care plans as everything else
            we ship.
          </p>
          <p className="ac-reveal" style={{ '--d': '0.18s' }}>
            The booking flow on this very site runs on it.
          </p>
          <div className="ac-apps-ctas ac-reveal" style={{ '--d': '0.24s' }}>
            <Link className="ac-btn" to="/contact?interest=web">Build an app</Link>
            <Link className="ac-textlink" to="/pricing">App builds from $7,500 →</Link>
          </div>
        </div>
        <WidgetGrid />
      </div>
    </section>
  );
}
